(function(){
  const STORAGE_KEY = 'mm.compare.list'; // stores array of product handles
  const MAX_ITEMS = 4;

  function getList(){
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e){ return []; }
  }
  function setList(arr){ localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); }
  function inList(handle){ return getList().includes(handle); }
  function add(handle){ const l=getList(); if(l.includes(handle)) return l; if(l.length>=MAX_ITEMS) l.shift(); l.push(handle); setList(l); dispatchChange(); return l; }
  function removeHandle(handle){ const l=getList().filter(h=>h!==handle); setList(l); dispatchChange(); return l; }
  function clearAll(){ setList([]); dispatchChange(); }
  function dispatchChange(){ document.dispatchEvent(new CustomEvent('mm:compare:changed', {detail:getList()})); }

  // Fetch public product JSON by handle
  async function fetchProduct(handle){
    const res = await fetch(`/products/${handle}.js`);
    if(!res.ok) throw new Error('Product not found: '+handle);
    return res.json();
  }

  // --- Button wiring (PDP + cards) ---
  function initButtons(){
    document.querySelectorAll('[data-mm-compare-handle]').forEach(btn => {
      const handle = btn.getAttribute('data-mm-compare-handle');
      const pressed = inList(handle);
      btn.setAttribute('aria-pressed', pressed);
      btn.addEventListener('click', () => {
        if(inList(handle)) removeHandle(handle); else add(handle);
      });
    });
  }

  // --- Drawer UI ---
  function drawerTemplate(){
    return `
    <div class="mm-compare-drawer" hidden>
      <div class="mm-compare-drawer__header">
        <span>Compare (<span id="mm-count">0</span>)</span>
        <button type="button" id="mm-close" aria-label="Close">×</button>
      </div>
      <div class="mm-compare-drawer__list" id="mm-list"></div>
      <div class="mm-compare-drawer__footer">
        <a class="mm-compare-link" href="/pages/compare">Open compare page</a>
        <button class="mm-compare-clear" type="button" id="mm-clear">Clear</button>
      </div>
    </div>`;
  }

  function ensureDrawer(){
    if(document.querySelector('.mm-compare-drawer')) return;
    const wrap = document.createElement('div');
    wrap.innerHTML = drawerTemplate();
    document.body.appendChild(wrap.firstElementChild);
    const drawer = document.querySelector('.mm-compare-drawer');
    document.getElementById('mm-close').addEventListener('click', ()=> drawer.hidden = true);
    document.getElementById('mm-clear').addEventListener('click', ()=> clearAll());
  }

  async function renderDrawer(){
    ensureDrawer();
    const drawer = document.querySelector('.mm-compare-drawer');
    const listEl = document.getElementById('mm-list');
    const handles = getList();
    document.getElementById('mm-count').textContent = String(handles.length);
    listEl.innerHTML = '';

    if(handles.length === 0){ drawer.hidden = true; updatePressedStates(); return; }

    drawer.hidden = false;
    for(const h of handles){
      try{
        const p = await fetchProduct(h);
        const img = (p.images && p.images[0]) || '';
        const div = document.createElement('div');
        div.className = 'mm-compare-pill';
        div.innerHTML = `
          ${img ? `<img src="${img}" alt="${p.title}">` : ''}
          <div title="${p.title}">${p.title}</div>
          <button type="button" data-remove="${h}">Remove</button>
        `;
        div.querySelector('[data-remove]').addEventListener('click', () => removeHandle(h));
        listEl.appendChild(div);
      }catch(err){ console.warn(err); }
    }
    updatePressedStates();
  }

  function updatePressedStates(){
    document.querySelectorAll('[data-mm-compare-handle]').forEach(btn => {
      const handle = btn.getAttribute('data-mm-compare-handle');
      btn.setAttribute('aria-pressed', inList(handle));
    });
  }

  // --- Compare Page Rendering ---
  async function renderComparePage(){
    const container = document.getElementById('mm-compare-container');
    if(!container) return;

    const handles = getList();
    if(handles.length === 0){
      container.innerHTML = `<div class="mm-compare-empty">No products added to compare yet.</div>`;
      return;
    }

    const products = [];
    for(const h of handles){ try { products.push(await fetchProduct(h)); } catch(e){ console.warn(e); } }
    const cols = products.length;

    const attrRows = [
      {key:'image', label:''},
      {key:'title', label:'Product'},
      {key:'price', label:'Price'},
      {key:'compare_at_price', label:'Compare at'},
      {key:'availability', label:'Availability'},
      {key:'vendor', label:'Brand'},
      {key:'product_type', label:'Type'},
      {key:'options', label:'Options'},
      {key:'tags', label:'Tags'}
    ];

    function getValue(prod, key){
      switch(key){
        case 'image': return prod.images && prod.images[0] ? `<img src="${prod.images[0]}" alt="${prod.title}" style="width:100px;height:100px;object-fit:cover;border-radius:.5rem;">` : '';
        case 'title': return `<a href="${prod.url}">${prod.title}</a>`;
        case 'price': return prod.price ? window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(prod.price) : `${(prod.price/100).toFixed(2)}` : '';
        case 'compare_at_price': return (prod.compare_at_price) ? (window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(prod.compare_at_price) : `${(prod.compare_at_price/100).toFixed(2)}`) : '-';
        case 'availability': return prod.available ? 'In stock' : 'Out of stock';
        case 'vendor': return prod.vendor || '';
        case 'product_type': return prod.type || '';
        case 'options': return (prod.options || []).map(o=>`${o.name}: ${o.values.slice(0,3).join(', ')}`).join('<br>');
        case 'tags': return (prod.tags||[]).slice(0,8).join(', ');
        default: return '';
      }
    }

    const table = document.createElement('div');
    table.className = 'mm-compare-grid mm-compare-table';
    table.style.setProperty('--mm-cols', String(cols));

    for(const row of attrRows){
      const head = document.createElement('div'); head.className = 'mm-compare-attr'; head.innerHTML = row.label; table.appendChild(head);
      for(const p of products){
        const cell = document.createElement('div');
        cell.innerHTML = `
          <div style="display:flex; justify-content:space-between; align-items:start; gap:.5rem;">
            <div>${getValue(p, row.key) || '-'}</div>
            ${row.key === 'title' ? `<button type="button" aria-label="Remove" data-mm-remove="${p.handle}" style="border:none;background:none;font-size:1.25rem;line-height:1;">×</button>` : ''}
          </div>`;
        const btn = cell.querySelector('[data-mm-remove]');
        if(btn) btn.addEventListener('click', () => removeHandle(p.handle));
        table.appendChild(cell);
      }
    }

    container.innerHTML = '';
    container.appendChild(table);
  }

  //
    // Re-render on compare changes
  document.addEventListener('mm:compare:changed', () => {
    renderDrawer();
    renderComparePage();
  });

  // Init
  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    renderDrawer();
    renderComparePage();
  });

})();